var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 2.66877L4.0013 2.67311C3.26492 2.67351 2.66829 3.27078 2.66869 4.00716L2.67303 12.0072C2.67342 12.7435 3.2707 13.3402 4.00708 13.3398L12.0071 13.3354C12.7435 13.335 13.3401 12.7378 13.3397 12.0014L13.3354 4.00138C13.335 3.265 12.7377 2.66837 12.0013 2.66877Z",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33626 6.00357L6.6696 6.00501C6.30141 6.00521 6.00309 6.30385 6.00329 6.67204L6.00474 9.33871C6.00494 9.7069 6.30357 10.0052 6.67176 10.005L9.33843 10.0036C9.70662 10.0034 10.0049 9.70473 10.0047 9.33654L10.0033 6.66987C10.0031 6.30168 9.70445 6.00337 9.33626 6.00357Z",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.001 1.33655L10.0017 2.66988",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0068 13.3366L10.0076 14.6699",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33887 10.0079L2.6722 10.0072",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33691 6.00794L2.67025 6.00721",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3389 10.0015L14.6722 10.0007",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3369 6.00147L14.6702 6.00074",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 1.33875L6.0017 2.67208",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00684 13.3387L6.00756 14.6721",
    stroke: "#7C3AED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00866935) rotate(-0.0310448)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.72045f0f21b859f8d98a3ab1684932e1.svg";
export { ForwardRef as ReactComponent };